import Pools from '@/modules/pools'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_public/_layout/pools/')({
  component: Pools,
})
